declare const __KSHOP_VERSION__: string;
declare const __KSHOP_COMMIT__: string;
declare const __KSHOP_BUILD_TIME__: string;

export const frontendBuild = {
  version: typeof __KSHOP_VERSION__ === "string" ? __KSHOP_VERSION__ : "0.0.0",
  commit: typeof __KSHOP_COMMIT__ === "string" ? __KSHOP_COMMIT__ : "local",
  buildTime: typeof __KSHOP_BUILD_TIME__ === "string" ? __KSHOP_BUILD_TIME__ : "",
};
